module.exports = __webpack_public_path__ + "static/img/msg.ada9082d.svg";